import React from "react";
import styled from "styled-components";
import { greyText, darkGreen } from "../../../styles";
import { CompassParagraph } from "../styledComponents";
import { CompassProgressBar } from "../CompassProgressBar";
import { AIJobProgress } from "../../../types/compassAITypes";
import {
  ElementContainer,
  RowContainer,
} from "../../containers/styledComponents";
import { formatReadable } from "../../../utils/formattingUtils";

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
`;

export interface JobProgressBarProps {
  progress: AIJobProgress;
}

export const JobProgressBar: React.FC<JobProgressBarProps> = ({ progress }) => {
  const { percentage, stepLabel, stepDetail } = progress;

  return (
    <Card>
      <ElementContainer flexDirection="column" w="100%">
        <RowContainer mt={1} mb={4} jc="flex-start">
          <CompassParagraph color={darkGreen} ws="nowrap">
            {stepLabel || "Starting…"}
          </CompassParagraph>

          {stepDetail && (
            <CompassParagraph
              fontSize={10}
              color={greyText}
              ws="nowrap"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {formatReadable(stepDetail)}
            </CompassParagraph>
          )}
        </RowContainer>
        <RowContainer ai="center" mt={1}>
          <CompassProgressBar value={percentage} max={100} height={10} />
          <CompassParagraph
            ml={12}
            fontSize={10}
            color={greyText}
            style={{ whiteSpace: "nowrap" }}
          >
            {percentage}%
          </CompassParagraph>
        </RowContainer>
      </ElementContainer>
    </Card>
  );
};
